import $ from 'jquery';

$(document).ready(function () {
  acfTestimonialsBlock();
});

function acfTestimonialsBlock() {
  $('.js-acf-testimonials-block').each(function () {
    $(".quoteWrapper").slick({
      dots: true,
      infinite: true,
      speed: 300,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
    });
  });
}
